<script setup lang="ts">
import type { MetadataVariant } from "#shared/types/cart";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  variant: MetadataVariant;
  quantity: number;
  stretch?: boolean;
}>();

const auth = useAuthorizeStore();

const isAdding = ref(false);

const cart = useCartStore();

const route = useRoute();

const subscriptions = useSubscriptions();

const toast = inject(keys.toast, null);

const totStudents = useTotStudents();

async function addToCart() {
  const quantity = props.variant.fixedAmount ? totStudents.value : props.quantity;

  const input = {
    variant: props.variant,
    amount: Math.max(quantity, 1),
  };

  if (!auth.loggedIn) {
    cart.addTempItem(input);
    return navigateToLogin(route);
  }

  if (!auth.canUseCart) {
    // TODO: Consider a toast?
    return;
  }

  const { data } = await subscriptions.suspense();
  const existingSubscription = data?.find(
    (it) => it.isbn === props.variant.sku && !it.isCancelled,
  );

  if (existingSubscription) {
    return toast?.info({
      message: `${auth.isConsumer ? "Du" : "Skolen din"} har et aktivt abonnement på dette produktet. Gå til Min Side for å kjøpe og øke antallet lisenser til skolen på deres abonnement på produktet.`,
      persistent: true,
      buttons: [
        {
          text: "Gå til Min side",
          onClick: () => {
            navigateTo("/minside#dine-abonnement");
          },
        },
      ],
    });
  }

  try {
    isAdding.value = true;

    await cart.add({
      variant: props.variant,
      amount: Math.max(quantity, 1),
    });
  } finally {
    isAdding.value = false;
  }
}
</script>

<template>
  <ClientOnly v-if="auth.isConsumer">
    <!-- TODO: Find out why this have to be client-only -->
    <vipps-mobilepay-button
      type="button"
      brand="vipps"
      language="no"
      variant="primary"
      :rounded="true"
      verb="buy"
      :branded="true"
      :disabled="isAdding"
      :loading="isAdding"
      @click="addToCart"
    />
  </ClientOnly>
  <UButton
    v-else
    :loading="isAdding"
    trailing
    class="flex w-fit justify-center rounded-full bg-yellow-30 px-m py-xs text-lg text-nowrap text-black-80 hover:bg-yellow-40"
    v-bind="$attrs"
    @click="addToCart()"
  >
    <slot />
  </UButton>
</template>
